import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";

export function AuthShell({ title, subtitle, children, footer }) {
    return (
        <div className="grid min-h-screen lg:grid-cols-[1fr_1.1fr]">
            <div className="flex flex-col px-6 py-8 sm:px-10 lg:px-16">
                <Brand />
                <div className="flex flex-1 flex-col justify-center py-12">
                    <div className="w-full max-w-md">
                        <h1 className="text-[32px] font-bold leading-[1.1] tracking-[-0.02em] text-ink lg:text-[40px]">
                            {title}
                        </h1>
                        {subtitle && (
                            <p className="mt-3 measure text-[16px] leading-[1.6] text-subtle">{subtitle}</p>
                        )}
                        <div className="mt-8">{children}</div>
                        {footer && <div className="mt-6 text-[14px] text-subtle">{footer}</div>}
                    </div>
                </div>
                <p className="text-[13px] text-subtle">
                    <Link to="/privacidad" className="hover:text-ink">
                        Privacidad y datos
                    </Link>
                </p>
            </div>

            {/* Panel de acento con prueba visual real */}
            <div className="relative hidden overflow-hidden bg-ink lg:block">
                <div
                    className="absolute -right-24 -top-24 h-96 w-96 rounded-full"
                    style={{ background: "radial-gradient(circle, hsl(14 45% 45% / 0.55), transparent 70%)" }}
                />
                <div
                    className="absolute -bottom-32 -left-16 h-96 w-96 rounded-full"
                    style={{ background: "radial-gradient(circle, hsl(14 45% 45% / 0.3), transparent 70%)" }}
                />
                <div className="relative flex h-full flex-col justify-center px-16">
                    <p className="eyebrow text-cream/60" style={{ fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase", letterSpacing: "0.14em", fontSize: "11.5px" }}>
                        Asesoría cosmética independiente
                    </p>
                    <p className="mt-6 font-display font-semibold leading-[0.95] text-cream" style={{ fontSize: "clamp(56px, 7vw, 104px)", letterSpacing: "0.01em" }}>
                        <span style={{ display: "inline-block", width: "0.14em", height: "0.14em", borderRadius: "50%", background: "#C9982F", marginRight: "0.2em", verticalAlign: "0.32em" }} aria-hidden="true" />MYAVEREN
                    </p>
                    <p className="mt-6 max-w-md text-[19px] leading-[1.5] text-cream/80">
                        Menos ruido, más criterio. La última palabra, la tuya.
                    </p>
                </div>
            </div>
        </div>
    );
}
